import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

type UserMergeTab = "merge" | "history";

/** The switch at the top of both account-merge pages: merging, and what was merged before. */
export default function UserMergeTabs({ active }: { active: UserMergeTab }) {
  const { t } = useTranslation();
  const { companyId } = useParams<{ companyId: string }>();

  const tabs: { id: UserMergeTab; label: string; to: string }[] = [
    {
      id: "merge",
      label: t("merge_tab_merge"),
      to: `/app/${companyId}/settings/user-merge`,
    },
    {
      id: "history",
      label: t("merge_tab_history"),
      to: `/app/${companyId}/user-merge-history`,
    },
  ];

  return (
    <nav className="flex gap-1 border-b border-gray-200">
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          to={tab.to}
          aria-current={tab.id === active ? "page" : undefined}
          className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
            tab.id === active
              ? "border-indigo-600 text-indigo-700"
              : "border-transparent text-gray-600 hover:text-gray-900"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
